import React from 'react';
import Kanban from './Kanban';
export default function Customers() {
  return <Kanban type="customer" title="Customers" />;
}
